/**
 * Composite emoji message component — drop-in for game screens.
 *
 * Combines EmojiFab + EmojiMessageOverlay.
 * Requires the parent container to have position: relative.
 */

import type { GameApi } from "../../services/game-api";
import { useEmojiMessages } from "../emoji-message-store";
import { EmojiFab } from "./EmojiFab";
import { EmojiMessageOverlay } from "./EmojiMessageOverlay";

interface EmojiMessagePanelProps {
  readonly gameApi: GameApi;
  readonly roomId: string;
  readonly displayName: string;
}

export function EmojiMessagePanel({
  gameApi,
  roomId,
  displayName,
}: EmojiMessagePanelProps) {
  const { activeMessages } = useEmojiMessages();

  return (
    <>
      <EmojiMessageOverlay messages={activeMessages} />
      <EmojiFab gameApi={gameApi} roomId={roomId} displayName={displayName} />
    </>
  );
}
